import React, { useMemo, useState } from "react";
import { useUser } from "../../context/UserContext";
import { Link, useLocation } from "react-router-dom";

const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbyrMbmemWZQCgJe1mFtbIDm0MEKYMpTk19-HkwEeo27VWkf5ZvIN-IU19E278I6aPQV/exec"; // 👈 yaha apna Apps Script Web App URL paste kar

const CommentSection = ({ promptTitle: promptTitleProp = "" }) => {
     const { user, userData } = useUser();
     const isLoggedIn = !!user;

     // optional: agar props se title na mile to page url se kuch value set
     const location = useLocation();
     const promptTitle = useMemo(() => {
          return promptTitleProp || location.pathname || "";
     }, [promptTitleProp, location.pathname]);

     const [comment, setComment] = useState("");
     const [name, setName] = useState(userData?.name || "");
     const [email, setEmail] = useState(userData?.email || "");
     const [loading, setLoading] = useState(false);

     const handleSubmit = async (e) => {
          e.preventDefault();
          if (!comment.trim()) return;

          setLoading(true);

          const formData = new FormData();
          formData.append("uid", userData?.uid || "");
          formData.append("prompts", promptTitle || "");
          formData.append("name", isLoggedIn ? (userData?.name || "") : name);
          formData.append("email", isLoggedIn ? (userData?.email || "") : email);
          formData.append("comment", comment);

          try {
               const res = await fetch(WEB_APP_URL, {
                    method: "POST",
                    body: formData,
               });

               const result = await res.text();

               if (result.trim() === "OK") {
                    alert("Feedback Submitted ✅");
                    setComment("");
                    if (!isLoggedIn) {
                         setName("");
                         setEmail("");
                    }
               } else {
                    alert(result || "Error submitting feedback ❌");
               }
          } catch (err) {
               console.error("Submit Error:", err);
               alert("Something went wrong ❌");
          } finally {
               setLoading(false);
          }
     };

     return (
          <section className="comment-area">
               <h3>Leave a Comment</h3>
               <p className="notice">
                    Your email address will not be published. Required fields are marked *
               </p>

               <form className="comment-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                         <textarea
                              placeholder="Write your comment here..."
                              required
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                         />
                    </div>

                    <div className="input-grid">
                         <input
                              type="text"
                              placeholder="Name*"
                              value={isLoggedIn ? (userData?.name || "") : name}
                              onChange={(e) => setName(e.target.value)}
                              readOnly={isLoggedIn}
                              required
                         />
                         <input
                              type="email"
                              placeholder="Email*"
                              value={isLoggedIn ? (userData?.email || "") : email}
                              onChange={(e) => setEmail(e.target.value)}
                              readOnly={isLoggedIn}
                              required
                         />
                    </div>

                    {isLoggedIn ? (
                         <button type="submit" className="post-btn" disabled={loading}>
                              {loading ? "Posting..." : "Post Comment"}
                         </button>
                    ) : (
                         <Link to="/login" className="post-btn">
                              Login Now
                         </Link>
                    )}
               </form>
          </section>
     );
};

export default CommentSection;